import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getBranch, groupList } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
});

function BranchAction(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const {
    title,
    popupTitle,
    api,
    name,
    description,
    setAsPrimary,
    id,
    status
  } = props;

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <Button className="bg-thememain text-black" onClick={handleShow}>
        {title === "Branch" ? "Add" : <i className="bi bi-pen-fill"></i>} {title}
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{popupTitle}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            const apiResp = await dispatch(api(values));
            if (apiResp?.payload.status) {
              resetForm({ values: "" });
              handleClose();
              dispatch(getBranch());
            }
          }}
          initialValues={{
            name,
            description,
            setAsPrimary,
            status,
            id
          }}
        >
          {({ handleSubmit, handleChange, values, setFieldValue, errors }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
              <Col md={6} sm={12}>
                  <Form.Label>Set As Primary Branch</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={(e) => {
                      setFieldValue("setAsPrimary", /true/.test(e.target.value));
                    }}
                    name="setAsPrimary"
                    className="form-control"
                    value={values.setAsPrimary}
                    isInvalid={!!errors.setAsPrimary}
                  >
                    <option value="">Select Primary</option>
                    <option value="true">Active</option>
                    <option value="false">InActive</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.setAsPrimary}
                  </Form.Control.Feedback>
                </Col>
                <Col md={6} sm={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={(e) => {
                      setFieldValue("status", /true/.test(e.target.value));
                    }}
                    name="status"
                    className="form-control"
                    value={values.status}
                    isInvalid={!!errors.status}
                  >
                    <option value="">Select Status</option>
                    <option value="true">Active</option>
                    <option value="false">InActive</option>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.status}
                  </Form.Control.Feedback>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} sm={12}>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={3}
                      placeholder="Description"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      isInvalid={!!errors.description}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.description}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Submit
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default BranchAction;
